import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../../../store';
import { STYLES } from '../../consts';
import Heading from '../../../../../../generic-components/Heading';

export const BillNumber = () => {
  const { billData, setBillData } = useStore(state => state);
  const { t } = useTranslation();

  const computedInputValue = useMemo(() => {
    if (billData.billNumber) {
      return `#${billData.billNumber}`;
    }
    return '';
  }, [billData.billNumber]);
  const handleChange = (e: any) => {
    setBillData({ ...billData, billNumber: e.target.value.replaceAll('#', '') });
  };
  return (
    <div className={STYLES.CREATE_BILL_BODY.BILL_NUMBER.WRAPPER}>
      <div className={STYLES.CREATE_BILL_BODY.BILL_NUMBER.HEADER_WRAPPER}>
        <Heading title={t('CREATE_BILL.FORM.NUMBER')} className={STYLES.CREATE_BILL_BODY.BILL_NUMBER.TITLE} />
      </div>
      <input className={STYLES.CREATE_BILL_BODY.BILL_NUMBER.INPUT} type='text' placeholder='#0000' maxLength={20} value={computedInputValue} onChange={handleChange} id='billNumber' />
    </div>
  );
};
